import * as actionTypes from '../constants/actionType';
import * as apiActions from './apiActions';
import * as apiValues from '../constants/apiValues';
import { loadNewsForRelatedProject } from './mLatestNewsActions';

//Action Creators
export const setShowFeatures = (showFeatures) => {
  return {
    type: actionTypes.PAGE_PROJECTS_DETAIL_FEATURE_TOGGLE,
    showFeatures,
  };
};

export const loadPageProjectDetailStart = () => {
  return {
    type: actionTypes.PAGE_PROJECTS_DETAIL_LOAD_START,
  };
};

export const loadPageProjectDetailSuccess = (result) => {
  return {
    type: actionTypes.PAGE_PROJECTS_DETAIL_LOAD_SUCCESS,
    result,
  };
};

function normalizeProjectFeatures(projectFeatures) {
  const features = projectFeatures
    ? apiActions.arraySelectCamelCaseKeys(projectFeatures, apiValues.nref.projectFeature.fieldsUsed)
    : [];
  features.forEach((projectFeature) => {
    projectFeature.projectFeatureLocations = apiActions.arraySelectCamelCaseKeys(
      projectFeature.projectFeatureLocations, apiValues.nref.projectFeatureLocation.fieldsUsed,
    );
  });
  return features;
}

export const initPageProjectDetail = (slug) => (dispatch) => {
  dispatch(loadPageProjectDetailStart());
  return new Promise((resolve, reject) => {
    Promise.all([
      apiActions.loadEndpoint(apiValues.nref.project.endpoint, null, {Slug: slug}),
      apiActions.loadEndpoint(apiValues.nref.projectFeature.endpoint, null, {_limit: 200}),
    ])
      .then(([results, featureCatalogResults]) => {
        const match = apiActions.pickBestProjectMatch(
          Array.isArray(results) ? results : results ? [results] : [],
        );
        let project = apiActions.itemSelectCamelCaseKeys(match, apiValues.nref.project.fieldsUsed);
        project.projectFeatures = normalizeProjectFeatures(project.projectFeatures);
        project.projectPartners = project.projectPartners ? apiActions.arraySelectCamelCaseKeys(project.projectPartners, apiValues.nref.projectPartner.fieldsUsed) : [];
        project.contacts = project.contacts ? apiActions.arraySelectCamelCaseKeys(project.contacts, apiValues.nref.contact.fieldsUsed) : [];
        project.program = project.program ? apiActions.itemSelectCamelCaseKeys(project.program, apiValues.nref.program.fieldsUsed) : undefined;
        project.projectstatus = project.projectstatus ? apiActions.itemSelectCamelCaseKeys(project.projectstatus, apiValues.nref.projectStatus.fieldsUsed) : undefined;
        project.tags = project.tags ? apiActions.arraySelectCamelCaseKeys(project.tags, apiValues.nref.tag.fieldsUsed) : [];
        const featureCatalog = normalizeProjectFeatures(
          Array.isArray(featureCatalogResults) ? featureCatalogResults : [],
        );
        let page = {
          ...project,
          project: project,
          featureCatalog,
        };

        return page;
      })
      .then(page => {
        return Promise.all([
          apiActions.loadEndpoint(apiValues.nref.event.endpoint, null, {
            RelatedProject_in: page.project.id,
            EventDate_gt: new Date().toISOString(),
            _sort: 'EventDate:asc',
          }),
          loadNewsForRelatedProject(page.project),
        ]).then(([events, news]) => {
          page.latestEvents = Array.isArray(events)
            ? apiActions.arraySelectCamelCaseKeys(events, apiValues.nref.event.fieldsUsed)
            : [];
          page.latestNews = Array.isArray(news) ? news : [];

          return page;
        });
      })
      .then(results => {
        resolve(dispatch(loadPageProjectDetailSuccess(results)));
      })
      .catch(error => {
        console.error(error);
        reject(error);
      });
  });
};
